import { gql } from "@apollo/client";

export const GET_PROFESIONALES_CONTRATO = gql`
query EvaluacionProfesionalCPByIdEvaluacion (
    $idEvaluacion: Int!
) {
    evaluacionProfesionalCPByIdEvaluacion (
        idEvaluacion: $idEvaluacion
    ){
      idTipoProf
      idTipoProfNavigation {
        descripcion
      }
      idTipoEspecialidad
      idTipoEspecialidadNavigation {
        descripcion
      }
    }
}`;

export const adaptProfesionalesContrato = (profesional) => {
  return {
    profesionalRI: {
      profesionalRI: profesional?.evaluacionProfesionalCPByIdEvaluacion?.filter((x) => !!x.idTipoProf).map((x) => x.idTipoProfNavigation.descripcion),
      profesionalEspecialidadRI: profesional?.evaluacionProfesionalCPByIdEvaluacion?.filter((x) => !!x.idTipoEspecialidad).map((x) => x.idTipoEspecialidadNavigation.descripcion)
    }
  };
};

export const adaptProfesionalesIdsContrato = (profesional) => {
  return {
    profesionalRI: {
      profesionalRI: profesional?.evaluacionProfesionalCPByIdEvaluacion?.filter((x) => !!x.idTipoProf).map((x) => x.idTipoProf),
      profesionalEspecialidadRI: profesional?.evaluacionProfesionalCPByIdEvaluacion?.filter((x) => !!x.idTipoEspecialidad).map((x) => x.idTipoEspecialidad)
    }
  };
};